import React, { Component } from "react";
import {
  message,
  Row,
  Col,
  Divider,
  Select,
  Table,
  Input,
  Typography,
  Tag,
  Tooltip,
  Badge,
} from "antd";
import {
  dineroDisabledMask,
  InputNumberItem,
  ButtonItem,
  ModalItem,
  round2Decimals,
} from "../../../../../Components/Items";

const { Title, Text } = Typography;

const motivos = [
  { value: "PRECIO_CAMBIO", label: "Precio de proveedor cambió" },
  { value: "DESCUENTO_EXTRA", label: "Descuento adicional" },
  { value: "FLETE_SEGURO", label: "Flete / Seguro" },
  { value: "REDONDEO", label: "Redondeo" },
  { value: "ERROR_ODC", label: "Error en ODC" },
];

class ManualMatchModal extends Component {
  state = {
    selectedXML: null,
    selectedODC: null,
    mapeos: this.props.mapeos || [],
    filterXML: "",
    filterODC: "",
    agregarAOC: [], // arreglo de xmlIdx que se agregarán a la OC
  };

  toggleAgregarAOC = (xmlIdx) => {
    this.setState((state) => {
      const yaEsta = state.agregarAOC.includes(xmlIdx);
      return {
        agregarAOC: yaEsta
          ? state.agregarAOC.filter((i) => i !== xmlIdx)
          : [...state.agregarAOC, xmlIdx],
        // Si lo seleccionaste como XML activo y lo marcas para agregar a OC,
        // limpia la selección para que no pueda emparejarse.
        selectedXML:
          !yaEsta && state.selectedXML?.idx === xmlIdx
            ? null
            : state.selectedXML,
      };
    });
  };

  componentDidUpdate(prevProps) {
    // Si cambian mapeos desde afuera, sincroniza
    if (prevProps.mapeos !== this.props.mapeos) {
      this.setState({ mapeos: this.props.mapeos || [] });
    }
  }

  agregarMapeo = () => {
    const { selectedXML, selectedODC, mapeos, agregarAOC } = this.state;
    if (selectedXML == null || selectedODC == null)
      return message.warning("Selecciona un XML y un ODC");
    if (agregarAOC.includes(selectedXML.idx))
      return message.warning(
        "Este insumo está marcado para agregarse a la OC. Quítalo de esa lista para poder emparejarlo."
      );
    const existe = mapeos.find(
      (m) => m.xmlIdx === selectedXML.idx && m.odcIdx === selectedODC.idx
    );
    if (existe) return message.info("Ya existe este emparejamiento");
    const cantidadesEmparejadas = {};
    this.state.mapeos.forEach((m) => {
      if (!cantidadesEmparejadas[m.xmlIdx]) {
        cantidadesEmparejadas[m.xmlIdx] = 0;
      }
      cantidadesEmparejadas[m.xmlIdx] += m.cantidadARecibir || 0;
    });
    const emparejado = cantidadesEmparejadas[selectedXML.idx] || 0;
    const faltante = round2Decimals(selectedXML.cantidad - emparejado);
    const sugerida = Math.min(faltante, selectedODC.pendiente);
    this.setState({
      mapeos: [
        ...mapeos,
        {
          xmlIdx: selectedXML.idx,
          odcIdx: selectedODC.idx,
          cantidadARecibir: sugerida,
          precioUnitario: selectedXML.valorUnitario,
          descuento: selectedXML.descuento || 0,
          precioFuente: "XML",
          precioOtro: null,
          usarDescuentoXML: true,
          motivo: null,
        },
      ],
      selectedXML: null,
      selectedODC: null,
    });
  };

  actualizarMapeo = (idx, patch) => {
    const m = [...this.state.mapeos];
    m[idx] = { ...m[idx], ...patch };
    this.setState({ mapeos: m });
  };

  eliminarMapeo = (idx) => {
    const m = [...this.state.mapeos];
    m.splice(idx, 1);
    this.setState({ mapeos: m });
  };

  onOk = () => {
    const { conceptosXML, odcPendientes } = this.props;
    const { agregarAOC } = this.state;
    const cantidadesEmparejadas = {};
    this.state.mapeos.forEach((m) => {
      if (!cantidadesEmparejadas[m.xmlIdx]) {
        cantidadesEmparejadas[m.xmlIdx] = 0;
      }
      cantidadesEmparejadas[m.xmlIdx] += m.cantidadARecibir || 0;
    });
    const sumBy = (arr, key) => arr.reduce((a, b) => a + (b[key] || 0), 0);
    for (const xml of conceptosXML) {
      // Saltar las líneas marcadas para agregarse a la OC: su cantidad no
      // se empareja, se enviará para crear renglón nuevo en la orden.
      if (agregarAOC.includes(xml.idx)) continue;
      const sumaXML = sumBy(
        this.state.mapeos.filter((m) => m.xmlIdx === xml.idx),
        "cantidadARecibir"
      );
      const emparejado = cantidadesEmparejadas[xml.idx] || 0;
      const faltante = round2Decimals(xml.cantidad - emparejado);

      if (faltante > 0) {
        return message.error(`XML línea ${xml.idx + 1} tiene cantidad faltante: ${faltante}`);
      }

      if (sumaXML > xml.cantidad + 1e-6)
        return message.error(`XML línea ${xml.idx + 1} excede cantidad`);
    }
    for (const odc of odcPendientes) {
      const sumaODC = sumBy(
        this.state.mapeos.filter((m) => m.odcIdx === odc.idx),
        "cantidadARecibir"
      );
      if (sumaODC > odc.pendiente + 1e-6)
        return message.error(`ODC línea ${odc.idx + 1} excede pendiente`);
    }
    const insumosAgregarAOC = agregarAOC
      .map((idx) => conceptosXML.find((c) => c.idx === idx))
      .filter(Boolean);
    this.props.onConfirm(this.state.mapeos, insumosAgregarAOC);
  };

  render() {
    const { visible, onCancel, conceptosXML, odcPendientes } = this.props;
    const { selectedXML, selectedODC, mapeos, filterXML, filterODC, agregarAOC } =
      this.state;

    // Filtros simples
    const conceptosFiltrados = (conceptosXML || []).filter((cx) => {
      const q = filterXML.trim().toLowerCase();
      if (!q) return true;
      return (
        (cx.clave || "").toLowerCase().includes(q) ||
        (cx.descripcion || "").toLowerCase().includes(q)
      );
    });

    const odcFiltrados = (odcPendientes || []).filter((od) => {
      const q = filterODC.trim().toLowerCase();
      if (!q) return true;
      return (od.descripcion || "").toLowerCase().includes(q);
    });

    const cantidadesEmparejadas = {};
    mapeos.forEach((m) => {
      if (!cantidadesEmparejadas[m.xmlIdx]) {
        cantidadesEmparejadas[m.xmlIdx] = 0;
      }
      cantidadesEmparejadas[m.xmlIdx] += m.cantidadARecibir || 0;
    });

    // Columnas XML
    const colsXML = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        width: 120,
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        ellipsis: true,
      },
      {
        title: "Cant.",
        dataIndex: "cantidad",
        key: "cantidad",
        width: 90,
        align: "right",
        render: (v, record) => {
          const emparejado = cantidadesEmparejadas[record.idx] || 0;
          const faltante = record.cantidad - emparejado;

          if (faltante > 0 && emparejado > 0) {
            return <Text style={{ color: "#ff4d4f" }}>Falta: {faltante}</Text>;
          } else {
            return <Text>{record.cantidad}</Text>;
          }
        },
      },
      {
        title: "Precio",
        dataIndex: "valorUnitario",
        key: "valorUnitario",
        width: 120,
        align: "right",
        render: (v) => <Text>{dineroDisabledMask(v)}</Text>,
      },
      ...(this.props.puedeAgregarAOC
        ? [
            {
              title: "Acción",
              key: "agregarAOC",
              width: 150,
              align: "center",
              render: (_, record) => {
                const yaMarcado = agregarAOC.includes(record.idx);
                const tieneMapeo = mapeos.some(
                  (m) => m.xmlIdx === record.idx
                );
                const tooltip = yaMarcado
                  ? "Quitar de la lista para agregar a la OC"
                  : tieneMapeo
                  ? "Este insumo ya está emparejado. Elimina su emparejamiento para poder agregarlo a la OC."
                  : "Agregar este insumo del XML como nuevo renglón en la orden de compra";
                return (
                  <Tooltip title={tooltip}>
                    <ButtonItem
                      size="small"
                      type={yaMarcado ? "default" : "primary"}
                      danger={yaMarcado}
                      disabled={!yaMarcado && tieneMapeo}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.toggleAgregarAOC(record.idx);
                      }}
                    >
                      {yaMarcado ? "Quitar de OC" : "Agregar a OC"}
                    </ButtonItem>
                  </Tooltip>
                );
              },
            },
          ]
        : []),
    ];

    // Columnas ODC
    const colsODC = [
      {
        title: "Insumo",
        dataIndex: "descripcion",
        key: "descripcion",
        ellipsis: true,
      },
      {
        title: "Disponible",
        dataIndex: "pendiente",
        key: "pendiente",
        width: 90,
        align: "right",
        render: (v) => <Text>{v}</Text>,
      },
      {
        title: "Precio ODC",
        dataIndex: "precioODC",
        key: "precioODC",
        width: 120,
        align: "right",
        render: (v) => <Text>{dineroDisabledMask(v)}</Text>,
      },
    ];

    return (
      <ModalItem
        visible={visible}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Title level={4} style={{ margin: 0 }}>
              Emparejar manualmente XML ↔ Orden de Compra
            </Title>
            <Badge
              color="blue"
              text={
                <span>
                  Mapeos creados: <b>{mapeos.length}</b>
                </span>
              }
            />
          </div>
        }
        onOk={this.onOk}
        onCancel={onCancel}
        width={1500}
        destroyOnClose
        spinning={false}
        footer
      >
        {/* estilos ligeros */}
        <style>{`
          .mm-card{
            background:#fff; border:1px solid #f0f0f0; border-radius:12px; padding:12px;
          }
          .mm-header{
            display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:8px;
          }
          .mm-chip{
            display:inline-flex; align-items:center; gap:6px; padding:6px 10px; border-radius:999px; background:#f5f5f5; font-size:12px;
          }
          .row-selected{
            background: #e6f4ff !important;
          }
          .row-faltante{
            background: #f3d189ff !important;
          }
          .row-disponible{
            background: #a2fda2ff !important;
          }
          .row-agregar-oc{
            background: #d9d9d9 !important;
            opacity: 0.85;
          }
          .row-agregar-oc td{
            cursor: not-allowed;
          }
        `}</style>

        <Row gutter={16}>
          <Col span={10}>
            <div className="mm-card">
              <div className="mm-header">
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Title level={5} style={{ margin: 0 }}>
                    Conceptos XML
                  </Title>
                  <Tag color="blue">{conceptosFiltrados.length}</Tag>
                </div>
                <Input.Search
                  allowClear
                  placeholder="Buscar clave o descripción"
                  value={filterXML}
                  onChange={(e) => this.setState({ filterXML: e.target.value })}
                  style={{ width: 260 }}
                  size="middle"
                />
              </div>

              <Table
                size="small"
                bordered
                sticky
                rowKey={(r) => r.idx}
                columns={colsXML}
                dataSource={conceptosFiltrados}
                pagination={false}
                onRow={(record) => ({
                  onClick: () => {
                    if (agregarAOC.includes(record.idx)) return;
                    this.setState({ selectedXML: record });
                  },
                })}
                rowClassName={(record) => {
                  const emparejado = cantidadesEmparejadas[record.idx] || 0;
                  const faltante = record.cantidad - emparejado;

                  if (agregarAOC.includes(record.idx)) return "row-agregar-oc";
                  if (selectedXML?.idx === record.idx) return "row-selected";
                  if (faltante > 0) return "row-faltante"; // Cualquier faltante = naranja
                  return ""; // Solo sin color cuando está completo
                }}
              />

              <div style={{ marginTop: 8 }}>
                {selectedXML ? (
                  <span className="mm-chip">
                    <Text type="secondary">XML seleccionado:</Text>
                    <Tooltip title={selectedXML.descripcion}>
                      <Text strong ellipsis style={{ maxWidth: 280 }}>
                        {selectedXML.descripcion}
                      </Text>
                    </Tooltip>
                    <Tag>
                      Cant: <b>{selectedXML.cantidad}</b>
                    </Tag>
                    <Tag>
                      Precio: <b>{dineroDisabledMask(selectedXML.valorUnitario)}</b>
                    </Tag>
                  </span>
                ) : (
                  <Text type="secondary">Selecciona una línea de XML</Text>
                )}
              </div>
            </div>
          </Col>

          <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ textAlign: "center" }}>
              <ButtonItem type="primary" onClick={this.agregarMapeo} disabled={!selectedXML || !selectedODC}>
                Emparejar selección →
              </ButtonItem>
              <div style={{ marginTop: 8 }}>
                <Text type="secondary">
                  Empareja 1 a 1, luego ajusta abajo cantidades/precio.
                </Text>
              </div>
            </div>
          </Col>

          <Col span={10}>
            <div className="mm-card">
              <div className="mm-header">
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Title level={5} style={{ margin: 0 }}>
                    Renglones ODC (pendiente)
                  </Title>
                  <Tag color="green">{odcFiltrados.length}</Tag>
                </div>
                <Input.Search
                  allowClear
                  placeholder="Buscar insumo"
                  value={filterODC}
                  onChange={(e) => this.setState({ filterODC: e.target.value })}
                  style={{ width: 260 }}
                  size="middle"
                />
              </div>

              <Table
                size="small"
                bordered
                sticky
                rowKey={(r) => r.idx}
                columns={colsODC}
                dataSource={odcFiltrados}
                pagination={false}
                onRow={(record) => ({
                  onClick: () => this.setState({ selectedODC: record }),
                })}
                rowClassName={(record) => {
                  if (selectedODC?.idx === record.idx) return "row-selected";
                  if (record.pendiente > 0) return "row-disponible"; // Cualquier faltante = naranja
                  return ""; // Solo sin color cuando está completo
                }}
              />

              <div style={{ marginTop: 8 }}>
                {selectedODC ? (
                  <span className="mm-chip">
                    <Text type="secondary">ODC seleccionado:</Text>
                    <Tooltip title={selectedODC.descripcion}>
                      <Text strong ellipsis style={{ maxWidth: 280 }}>
                        {selectedODC.descripcion}
                      </Text>
                    </Tooltip>
                    <Tag color="green">
                      Pend: <b>{selectedODC.pendiente}</b>
                    </Tag>
                    <Tag>
                      Precio ODC: <b>{dineroDisabledMask(selectedODC.precioODC)}</b>
                    </Tag>
                  </span>
                ) : (
                  <Text type="secondary">Selecciona un renglón de la ODC</Text>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <Divider />

        <div className="mm-card">
          <div className="mm-header" style={{ marginBottom: 12 }}>
            <Title level={5} style={{ margin: 0 }}>
              Emparejamientos
            </Title>
            <Tag color="blue">Total: {mapeos.length}</Tag>
          </div>

          <div className="table small" style={{ overflowX: "auto" }}>
            <table className="table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: "26%" }}>XML</th>
                  <th style={{ width: "26%" }}>ODC</th>
                  <th style={{ width: 120, textAlign: "center" }}>Cantidad</th>
                  {/* <th style={{ width: 300 }}>Precio a usar</th> */}
                  {/* <th style={{ width: 140, textAlign: "center" }}>Descto XML</th> */}
                  <th style={{ width: 220 }}>Motivo</th>
                  <th style={{ width: 110 }}></th>
                </tr>
              </thead>
              <tbody>
                {mapeos.map((m, i) => {
                  const cx = conceptosXML[m.xmlIdx];
                  const od = odcPendientes[m.odcIdx];
                  const precioXML = cx?.valorUnitario ?? 0;
                  const precioODC = od?.precioODC ?? 0;

                  return (
                    <tr key={i}>
                      <td>
                        <Tooltip title={cx?.descripcion}>
                          <Text strong>{cx?.descripcion}</Text>
                        </Tooltip>
                        <div style={{ fontSize: 12, opacity: 0.7 }}>
                          Cant XML: {cx?.cantidad} · Precio XML:{" "}
                          {dineroDisabledMask(precioXML)}
                        </div>
                      </td>
                      <td>
                        <Tooltip title={od?.descripcion}>
                          <Text strong>{od?.descripcion}</Text>
                        </Tooltip>
                        <div style={{ fontSize: 12, opacity: 0.7 }}>
                          Pend ODC: {od?.pendiente} · Precio ODC:{" "}
                          {dineroDisabledMask(precioODC)}
                        </div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <InputNumberItem
                          min={0}
                          max={Math.min(cx?.cantidad || 0, od?.pendiente || 0)}
                          value={m.cantidadARecibir}
                          onChange={(v) =>
                            this.actualizarMapeo(i, {
                              cantidadARecibir: v || 0,
                            })
                          }
                          precision={2}
                        />
                      </td>
                      {/* <td>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                          <Select
                            value={m.precioFuente}
                            style={{ width: 140 }}
                            onChange={(v) =>
                              this.actualizarMapeo(i, { precioFuente: v })
                            }
                            options={[
                              { value: "XML", label: "Usar precio XML" },
                              { value: "ODC", label: "Usar precio ODC" },
                              { value: "Otro", label: "Capturar otro" },
                            ]}
                          />
                          {m.precioFuente === "Otro" && (
                            <InputNumberItem
                              style={{ width: 160 }}
                              value={m.precioOtro}
                              onChange={(v) =>
                                this.actualizarMapeo(i, { precioOtro: v })
                              }
                              dinero
                              precision={4}
                              placeholder="Precio"
                            />
                          )}
                          <div style={{ fontSize: 12, opacity: 0.7 }}>
                            Ref:&nbsp;
                            <Tooltip title="Precio XML">
                              <Tag>XML {dineroDisabledMask(precioXML)}</Tag>
                            </Tooltip>
                            <Tooltip title="Precio ODC">
                              <Tag>ODC {dineroDisabledMask(precioODC)}</Tag>
                            </Tooltip>
                          </div>
                        </div>
                      </td> */}
                      {/* <td style={{ textAlign: "center" }}>
                        <Select
                          value={m.usarDescuentoXML ? 1 : 0}
                          style={{ width: 120 }}
                          onChange={(v) =>
                            this.actualizarMapeo(i, {
                              usarDescuentoXML: v === 1,
                            })
                          }
                          options={[
                            { value: 1, label: "Usar" },
                            { value: 0, label: "No usar" },
                          ]}
                        />
                      </td> */}
                      <td>
                        <Select
                          value={m.motivo}
                          style={{ width: "100%" }}
                          onChange={(v) =>
                            this.actualizarMapeo(i, { motivo: v })
                          }
                          options={motivos}
                          allowClear
                          placeholder="Motivo"
                          showSearch
                          optionFilterProp="label"
                        />
                      </td>
                      <td>
                        <ButtonItem danger onClick={() => this.eliminarMapeo(i)}>
                          Eliminar
                        </ButtonItem>
                      </td>
                    </tr>
                  );
                })}
                {mapeos.length === 0 && (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", padding: 16, color: "#999" }}>
                      No hay emparejamientos aún. Selecciona una línea de XML y una de ODC y haz clic en <b>“Emparejar selección →”</b>.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </ModalItem>
    );
  }
}

export default ManualMatchModal;
